import React from 'react'
import { Text, ThemeProvider } from 'system'

import { theme } from './theme'

export const wrapPageElement = ({ element, props }) => {
  const location = props.location

  if (!location.pathname.startsWith('/admin')) return element

  return (
    <ThemeProvider theme={theme}>
      <Text
        fontFamily="sans"
        fontSizeScale="b"
        color="gray.20"
        lineHeight="copy"
      >
        {element}
      </Text>
    </ThemeProvider>
  )
}
